import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import * as filterActions from 'components/filter/actions';
import { loadUserRecommendations } from 'components/recommendation/actions';
import { track } from 'shared/models/analytic';
import { isEqual } from 'shared/models/address';
import Spinner from 'react-spinkit';
import { Link } from 'react-router-dom';
import HeadTags from './head';
import Filter from '../filter';
import ProductItem from '../productItem';
import Pagination from '../ui/pagination';
import Text from '../ui/text';
import View from '../ui/view';
import Recommendations from '../recommendation';
import BeerImage from 'images/beer.jpg';
import WineImage from 'images/wine.jpg';
import SpiritsImage from 'images/spirits.jpg';
import MoreImage from 'images/more.jpg';
import TextOverImage from '../ui/textOverImage';
import { pluralize } from '../../utils';
import { AsyncLeadCaptureModal } from 'components/async';

class Category extends React.Component {
  constructor(props) {
    super(props);
    this.imageRef = this.imageRef.bind(this);
    this.pathForOffset = this.pathForOffset.bind(this);
  }

  componentDidMount() {
    this.shouldLoadList({}, this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.address, nextProps.address)) {
      return this.loadList(nextProps);
    }

    this.shouldLoadList(this.props, nextProps);
  }

  // FIXME: This makes an unnecessary client-side request when the category/search
  // results page is server-rendered. Should compare route params (including query)
  // against redux state instead. Cf. product page
  shouldLoadList(prevProps, nextProps) {
    const prevLocation = prevProps.location || { pathname: '', search: '' };
    const nextLocation = nextProps.location || { pathname: '', search: '' };
    const prevPath = prevLocation.pathname + prevLocation.search;
    const nextPath = nextLocation.pathname + nextLocation.search;
    if (prevPath !== nextPath || prevProps.user !== nextProps.user) {
      this.props
        .syncWithQueryParams(nextLocation.search)
        .then(() => this.loadList(nextProps))
        .then(
          () =>
            this.listIsEmpty(this.props) && this.props.loadUserRecommendations()
        );
    }
  }

  loadList(props) {
    const categorySlug = props.match.params.category;
    return this.props
      .loadCategory({ categorySlug })
      .then(() => this.props.getAvailableFilters())
      .then(() => this.props.updateFilteredProducts())
      .then(() => {
        this.loadHeader();
        this._track();
        return null;
      });
  }

  loadHeader() {
    if (this.props.featuredBanner) return;
    const url = this._urlForCategory();
    const image = new Image();
    image.src = `https://saucey-media.s3.amazonaws.com/web/category-images/${url}-header-image.jpg`;
    image.onload = () => {
      this.headerImage.style.backgroundImage = `url(${image.src})`;
    };
    image.onerror = () => {
      this.headerImage.style.backgroundImage =
        'url(https://saucey-media.s3.amazonaws.com/web/category-images/category-generic-dark-header.jpg)';
    };
    this.headerLoaded = true;
  }

  listIsEmpty(props) {
    return (
      !props.loading &&
      !props.filtersLoading &&
      (!props.products || props.products.length == 0)
    );
  }

  _track() {
    track('Product List Viewed', {
      list_id: this.props.tag,
      category: this.props.title,
      products: this.props.products.map(item => ({ product_id: item.sku_id }))
    });
  }

  imageRef(el) {
    this.headerImage = el;
  }

  pathForOffset(skip) {
    return filterActions.pathForSelected(this.props.location, {
      ...this.props.selected,
      skip
    });
  }

  _classNameForCategory() {
    const title = this.props.title || this.props.url || '';
    return `category ${title.replace(/\s/g, '-').toLowerCase()}`;
  }

  _urlForCategory() {
    const title = this.props.title || this.props.url || '';
    return title
      .toLowerCase()
      .replace(/[^\w]/g, '')
      .replace(/\s/g, '-');
  }

  render() {
    const className = this._classNameForCategory();

    return (
      <div className={'banner-padding ' + className}>
        <HeadTags
          title={this.props.title}
          description={this.props.description}
          searchQuery={this.props.searchQuery}
          slug={this.props.slug}
        />

        {!this.props.searchQuery &&
          !this.props.featuredBanner && (
            <div className="category-header">
              <span ref={this.imageRef} className="category-header-image" />
              <div className="category-header-text">
                <span className="category-header-title text-large">
                  {this.props.title || this.props.name}
                </span>
                {!!this.props.subtitle && (
                  <span className="category-header-subtitle text-large-subtitle">
                    {this.props.subtitle}
                  </span>
                )}
              </div>
            </div>
          )}

        {this.props.featuredBanner && (
          <div>
            <Link to={this.props.featuredBanner.link}>
              <img src={this.props.featuredBanner.image} width="100%" />
            </Link>
          </div>
        )}

        <div className="row">
          <div className="category-filter-content">
            <Filter />
          </div>

          {this.listIsEmpty(this.props) ? (
            <div className="col-xs-12 col-sm-8 col-lg-9">
              <div className="category-main-content products">
                {!!this.props.searchQuery && (
                  <div className="search-query__container">
                    <h1 className="search-query__heading">
                      Results For{' '}
                      <span className="search-query__query">
                        {this.props.searchQuery}
                      </span>
                    </h1>
                    <h2 className="search-query__subheading">
                      We Found {this.props.count}{' '}
                      {pluralize('Result', this.props.count)}
                    </h2>
                  </div>
                )}

                <div className="category-products--empty">
                  {!!this.props.searchQuery && (
                    <View margin="lg" className="text-center">
                      <Text tag="span" weight="bold" size="md">
                        Sorry, your search for {this.props.searchQuery} did not
                        return any results.
                      </Text>
                    </View>
                  )}

                  {!!this.props.userRecommendations &&
                    !!this.props.userRecommendations.length && (
                      <div className="row">
                        <div className="col-xs-12">
                          <View margin="sm">
                            <Text title={true} weight="med">
                              Top Picks for{' '}
                              {this.props.user && this.props.user.firstname
                                ? this.props.user.firstname
                                : 'You'}
                            </Text>
                          </View>
                          <View margin="md">
                            <Recommendations
                              link={true}
                              list={this.props.userRecommendations}
                              responsive={[
                                {
                                  breakpoint: 1500,
                                  settings: {
                                    slidesToShow: 6,
                                    slidesToScroll: 6
                                  }
                                },
                                {
                                  breakpoint: 1400,
                                  settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 5
                                  }
                                },
                                {
                                  breakpoint: 1200,
                                  settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 4
                                  }
                                },
                                {
                                  breakpoint: 1100,
                                  settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3
                                  }
                                },
                                {
                                  breakpoint: 420,
                                  settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                  }
                                }
                              ]}
                            />
                          </View>
                        </div>
                      </div>
                    )}

                  <View margin="md">
                    <div className="divider-group">
                      <div className="divider-group__divider" />
                      <Text
                        title={true}
                        weight="med"
                        size="sm"
                        className="divider-group__text"
                      >
                        Browse By Category
                      </Text>
                      <div className="divider-group__divider" />
                    </div>
                  </View>
                  <div className="row">
                    <div className="col-xs-6 col-lg-3">
                      <TextOverImage
                        href="/beer"
                        text="Beer"
                        image={BeerImage}
                      />
                    </div>
                    <div className="col-xs-6 col-lg-3">
                      <TextOverImage
                        href="/wine"
                        text="Wine"
                        image={WineImage}
                      />
                    </div>
                    <div className="col-xs-6 col-lg-3">
                      <TextOverImage
                        href="/spirits"
                        text="Spirits"
                        image={SpiritsImage}
                      />
                    </div>
                    <div className="col-xs-6 col-lg-3">
                      <TextOverImage
                        href="/more"
                        text="More"
                        image={MoreImage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="category-main-content products">
              {!!this.props.searchQuery && (
                <div className="search-query__container">
                  <h1 className="search-query__heading">
                    Results For{' '}
                    <span className="search-query__query">
                      {this.props.searchQuery}
                    </span>
                  </h1>
                  <h2 className="search-query__subheading">
                    We Found {this.props.count}{' '}
                    {pluralize('Result', this.props.count)}
                  </h2>
                </div>
              )}
              <div className="category-products row products">
                {this.props.products.map((item, idx) => (
                  <ProductItem
                    {...item}
                    category={this.props.title}
                    className="col-xs-6 col-sm-6 col-md-4 col-lg-3 section"
                    key={idx + '-' + item.sku_id}
                  />
                ))}
                {!!this.props.count && (
                  <div className="category-pagination col-xs-12 col-lg-12">
                    <span className="category-pagination-count text-bold">
                      {this.props.count}{' '}
                      {pluralize('Product', this.props.count)}
                    </span>
                    <Pagination
                      itemCount={this.props.count}
                      offset={this.props.selected.skip}
                      pageSize={this.props.size}
                      pathForOffset={this.pathForOffset}
                    />
                  </div>
                )}
                {(this.props.loading || this.props.filtersLoading) && (
                    <div className="category-products-loading">
                      <Spinner spinnerName="three-bounce" />
                    </div>
                  )}
              </div>
            </div>
          )}
        </div>

        <AsyncLeadCaptureModal />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.category,
    products: state.filter.products,
    filtersLoading: state.filter.loading,
    count: state.filter.count,
    selected: state.filter.selected,
    size: state.filter.size,
    address: state.address,
    user: state.login.user,
    userRecommendations: state.recommendation.userRecommendations
  };
}

export default connect(mapStateToProps, {
  ...actions,
  resetFilters: filterActions.resetFilters,
  syncWithQueryParams: filterActions.syncWithQueryParams,
  updateFilteredProducts: filterActions.updateFilteredProducts,
  getAvailableFilters: filterActions.getAvailableFilters,
  loadUserRecommendations
})(Category);
export let component = Category;



// WEBPACK FOOTER //
// ./shared/components/category/index.js